import { SubNavItem } from "@tameeni/ui";
import { useConfig } from "@/hooks/use-config";
import { useLocale } from "@/hooks/use-locale";
import { useTranslation } from "react-i18next";

export function useHeader() {
  const config = useConfig();
  const locale = useLocale();
  const { t } = useTranslation();

  const HealthSubItems = () => {
    return (
      <div className="mt-2 flex w-full flex-col gap-4">
        <div>
          <h3 className="mb-2 text-xs text-slate-500">
            {t("homepage.forBusiness")}
          </h3>
          <div className="space-y-1">
            <SubNavItem
              icon="HealthSme"
              label={t("homepage.smeHealth_insurance")}
              description={t("homepage.smeHealthDescription")}
              link={`${config.TAMEENI_HOME}/health-sme`}
              className="border-none bg-transparent px-0 py-2 hover:bg-transparent"
              arrowClassName={arrowClassName}
            />
          </div>
        </div>
        <div>
          <h3 className="mb-2 text-xs text-slate-500">
            {t("homepage.forIndividual")}
          </h3>
          <div className="space-y-1">
            <SubNavItem
              icon="DomesticHelper"
              label={t("homepage.Domestic Insurance")}
              description={t("homepage.DomesticInsuranceDescription")}
              link={`${config.TAMEENI_HOME}/health`}
              className="border-none bg-transparent px-0 py-2 hover:bg-transparent"
              arrowClassName={arrowClassName}
            />
          </div>
        </div>
      </div>
    );
  };

  const arrowClassName = locale === "ar" ? "rotate-180" : "";

  const sideNavItems = [
    {
      label: t("homepage.products"),
      items: [
        {
          icon: "MotorColored",
          isActive: true,
          label: t("homepage.car_insurance"),
          link: `${config.TAMEENI_HOME}`,
        },
        {
          icon: "HealthColored",
          label: t("homepage.health_insurance"),
          link: "#",
          subItems: <HealthSubItems />,
        },
        {
          icon: "MMPColored",
          label: t("homepage.MMP_insurance"),
          link: `${config.TAMEENI_HOME}/mmp`,
        },
        {
          icon: "TravelColored",
          label: t("homepage.travel_insurance"),
          link: `${config.TAMEENI_HOME}/travel`,
        },
      ],
    },
    {
      label: t("homepage.support"),
      items: [
        {
          label: t("homepage.contact_us"),
          link: `${config.TAMEENI_HOME}/contact-us`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
        {
          label: t("homepage.privacy_policy"),
          link: `${config.TAMEENI_HOME}/privacy-policy`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
        {
          label: t("homepage.terms_and_conditions"),
          link: `${config.TAMEENI_HOME}/terms-and-conditions`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
      ],
    },
    {
      label: t("homepage.resources"),
      items: [
        {
          label: t("homepage.faq"),
          link: `${config.TAMEENI_HOME}/faq`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
        {
          label: t("homepage.insurance_authority_publications"),
          link: `${config.TAMEENI_HOME}/SamaPolicies`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
        {
          label: t("homepage.career"),
          link: `${config.TAMEENI_HOME}/career`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
        {
          label: t("homepage.partners"),
          link: `${config.TAMEENI_HOME}/Partners`,
          icon: "LinkArrow",
          iconClassName: arrowClassName,
        },
      ],
    },
  ];

  const socialLinks = [
    {
      label: "X",
      url: "https://twitter.com/TameeniKSA",
      icon: "XLogo",
    },
    {
      label: "Facebook",
      url: "https://www.facebook.com/Tameeniksa/",
      icon: "Facebook",
    },
    {
      label: "Instagram",
      url: "https://www.instagram.com/tameeniksa",
      icon: "Instagram",
    },
    {
      label: "Snapchat",
      url: "https://www.snapchat.com/add/tameeniksa",
      icon: "Snapchat",
    },
    {
      label: "Youtube",
      url: "https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/",
      icon: "Youtube",
    },
  ];

  return {
    sideNavItems,
    socialLinks,
  };
}
